import React, { useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import InputSelectControl from "~/components/InputSelectControl";
import { useDispatch, useSelector } from "react-redux";
import memberSelectors from "~/store/members/selectors";
import authSelectors from "~/store/auth/selectors";
import { StatusStateEnum } from "~/types/enums";
import membersActionCreators from "~/store/members/actions";
const Fieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const InviteTemporaryMemberForm = _ref => {
  let {
    control
  } = _ref;
  const {
    t
  } = useTranslation();
  const user = useSelector(authSelectors.getUser);
  const userRoleWeight = user.role.weight;
  const roles = useSelector(memberSelectors.getRoles);
  const rolesStatus = useSelector(memberSelectors.getRolesStatus);
  const dispatch = useDispatch();
  const filteredRoles = roles.filter(_ref2 => {
    let {
      weight
    } = _ref2;
    return weight <= userRoleWeight;
  }).map(_ref3 => {
    let {
      id,
      name,
      description
    } = _ref3;
    return {
      id,
      value: name,
      tip: description
    };
  });
  useEffect(() => {
    if (rolesStatus === StatusStateEnum.IDLE) {
      dispatch(membersActionCreators.fetchRolesStarted());
    }
  }, [rolesStatus]);
  return /*#__PURE__*/React.createElement(Fieldset, null, /*#__PURE__*/React.createElement(InputSelectControl, {
    name: "roleId",
    label: t("InviteTemporaryMemberForm.role"),
    options: filteredRoles,
    control: control,
    required: true
  }));
};
export default InviteTemporaryMemberForm;